import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';
import { Spin, Table, Modal, Progress } from 'antd';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import ServicioDatosConstantes from '../../servicios/ServicioDatosConstantes';
import { withCookies } from 'react-cookie';
import Constantes from '../../utilidades/Constantes'
import FiltroColumna from '../../general/tabla/FiltroColumna'
import FiltroEtiqueta from '../../general/tabla/FiltroEtiqueta'
import _ from 'lodash';




class ReporteApoderados extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        descargando: false,

        filtro: {},
        filtroEtiquetas: [],
        filtroApi : {},
        paginacion: {
            current: 1,
            pageSize: 10,
        },
        cargandoTabla: true
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
        this.servicioDatosConstantes = new ServicioDatosConstantes(props);

        let contexto = this;
        this.filtroColumna = new FiltroColumna(props, (valores) => { contexto.setSumaState(valores, contexto) });
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.onRef(this)
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.onRef(undefined)
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario esté en sesion
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr != null) {

            const estados = await this.servicioDatosConstantes.obtenerEstadosApoderado();
            let estadosApoderados = [];
            if (estados) {
                for (let estado of estados) {
                    estadosApoderados.push({ label: estado.estadoApoderado, value: estado.id });
                }
            }

            await this.cargarDatosTabla(this);
            this.setSumaState({ componente: this.ENUM_COMPONENTE.VER, cargando: false, usuario: usr, estadosApoderados });

        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
        // Esto le avisa al contenedor padre (ReportesUsuarios.js) que ya cargó lo datos
        this.props.onCargado(true);
    }

    // 'limpiarFiltro': Método (clearFilters) que es propio de la tabla antDesign para limpiar los filtros
    // 'confirmarFiltro': Método (confirm) que es própio de la tabla antDesign para aplicar el filtro
    // 'dataIndex': Retorna el campo que se está filtrando
    // 'selectedKeys': Retorna el valor a filtrar;
    async cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) {
        let filtro = contexto.state.filtro;
        if (dataIndex !== undefined) { // Si el filtro es aplicado, se agrega la columna filtrada
            filtro[dataIndex] = selectedKeys;
        }
        contexto.setSumaState({ filtro: filtro });

        // Se construye el filtroApi a partir de lo que fue filtrado en la tabla
        let filtroApi = {
            ...(filtro.idApoderado && filtro.idApoderado.length > 0 && { id: filtro.idApoderado[0] }),
            ...(filtro.nombre && filtro.nombre.length > 0 && { nombre: filtro.nombre[0] }),
            ...(filtro.numeroDocumento && filtro.numeroDocumento.length > 0 && { identificacion: filtro.numeroDocumento[0] }),
            ...(filtro.correoElectronico && filtro.correoElectronico.length > 0 && { correoElectronico: filtro.correoElectronico[0] }),
            ...(filtro.estadoApoderado && filtro.estadoApoderado.length > 0 && filtro.estadoApoderado[0].opc && { estado: filtro.estadoApoderado[0].opc.join() }),
            ...(filtro.tipoDocumento && filtro.tipoDocumento.length > 0 && { tipoDocumento: filtro.tipoDocumento[0] }),
            ...(filtro.tipoPersona && filtro.tipoPersona.length > 0 && { tipoPersona: filtro.tipoPersona[0] }),
            ...(filtro.nombrePersona && filtro.nombrePersona.length > 0 && { nombrePersona: filtro.nombrePersona[0] }),
            ...(filtro.tipoDocumentoPersona && filtro.tipoDocumentoPersona.length > 0 && { tipoDocumentoPersona: filtro.tipoDocumentoPersona[0] }),
            ...(filtro.numeroDocumentoPersona && filtro.numeroDocumentoPersona.length > 0 && { numeroDocumentoPersona: filtro.numeroDocumentoPersona[0] }),  
            detallado:this.props.detallado
        };

        const paginacion = this.state.paginacion;
        let paginacionApi = {
            paginaActual:this.state.paginacion.current,
            paginaTamano:this.state.paginacion.pageSize,
            ordenarColumna:this.state.paginacion.ordenarColumna,
            orden: this.state.paginacion.orden
        }

        let cambio = false;
        // Primero valida si hubo cambio a nivel de filtro
        if( !_.isEqual(this.state.filtroApi, filtroApi) ){
            paginacion.current = 1;
            paginacionApi.paginaActual = 1;
            cambio = true;
        }

        // Segundo valida si hubo cambio a nivel de paginación
        if( !cambio && !_.isEqual(this.state.paginacionApi, paginacionApi) ){
            cambio = true;
        }
        
        if( !cambio ){
            // Si no hubo cambio no se hace nada
            return;
        }

        contexto.setSumaState({  
            cargandoTabla: true, 
            filtro, 
            filtroApi, 
            paginacionApi, 
            paginacion
        });

        await this.servicioAdministracion.obtenerApoderadosSuma(
                {
                    ...filtroApi,
                    ...paginacionApi
                }
            )
            .then((respuestaApi) => {
                if (respuestaApi) {
                    
                    switch (respuestaApi.codigo) {
                        case Constantes.ENUMS_API.ADMINISTRACION.DATOS_RETORNADOS.id:
                            let tablaPaginada = respuestaApi.resultado;
                            const paginacion = this.state.paginacion;
                            paginacion.total = tablaPaginada.total;

                            contexto.setSumaState({
                                apoderados: tablaPaginada.registros,
                                cargandoTabla: false,
                                paginacion
                            });
                            
                            break;
                        default: break;
                    }
                    
                }
            }).then(() => {
                if (limpiarFiltro !== undefined) { limpiarFiltro(); }
                if (confirmarFiltro !== undefined) { confirmarFiltro(); }
            });
    }

    async descargarReporte() {
        let contexto = this;
        contexto.setSumaState({ descargando: true, porcentaje: 0 });
        await this.servicioAdministracion.descargarReporteApoderadosSuma(
            {
                ...this.state.filtroApi,
                ...this.state.paginacionApi,
                paginaActual : 1,
                paginaTamano : -1
            },
            (percentCompleted) => {
                contexto.setSumaState({ porcentaje: percentCompleted });
            }
        )
            .then((respuesta) => {
                if (respuesta) {
                    switch (respuesta.status) {
                        case 200:
                            const type = respuesta.headers['content-type'];
                            const nombre = respuesta.headers['filename'];
                            const blob = new Blob([respuesta.data], { type: type });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = nombre;
                            link.click();
                            link.remove();
                            this.setSumaState({ descargando: false });
                            break;
                        default:
                            this.setSumaState({ descargando: false });
                            Modal.error({ content: "No fue posible generar el reporte de los apoderados del SUMA. [Cod:RAPO01]" });
                            break;
                    }
                }
            });
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const paginacion = this.state.paginacion;
        paginacion.current = pagination.current;
        paginacion.pageSize = pagination.pageSize;
        paginacion.ordenarColumna = sorter.field;
        paginacion.orden = sorter.order;
        this.setSumaState({  paginacion });
        await this.cargarDatosTabla(this);
    };

    render() {

        const { apoderados, componente, descargando, porcentaje, estadosApoderados } = this.state;
        const { detallado } = this.props;
        let { filtro } = this.state;
        filtro = filtro || {};
        let contexto = this;

        const columns = [
            ...(detallado ? 
            [{
                title: 'Id',
                dataIndex: 'idApoderado',
                key: 'idApoderado',
                with: 100,
                sorter: (a, b) => 0, //a.id - b.id,
                filteredValue: filtro.id || null,
                ...this.filtroColumna.busquedaTexto(
                    'Identificador',
                    'idApoderado',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            }]:[]),
            {
                title: 'Nombre',
                dataIndex: 'nombre',
                key: 'nombre',
                sorter: (a, b) => 0, //a.nombre ? a.nombre.localeCompare(b.nombre) : 1,
                filteredValue: filtro.nombre || null,
                ...this.filtroColumna.busquedaTexto(
                    'Nombre',
                    'nombre',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Tipo documento',
                dataIndex: 'tipoDocumento',
                key: 'tipoDocumento',
                sorter: (a, b) => 0, //a.tipoDocumento ? a.tipoDocumento.localeCompare(b.tipoDocumento) : 1,
                filteredValue: filtro.tipoDocumento || null,
                ...this.filtroColumna.busquedaTexto(
                    'Tipo Documento',
                    'tipoDocumento',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Número documento',
                dataIndex: 'numeroDocumento',
                key: 'numeroDocumento',
                sorter: (a, b) => 0, //a.numeroDocumento ? a.numeroDocumento.localeCompare(b.numeroDocumento) : 1,
                filteredValue: filtro.numeroDocumento || null,
                ...this.filtroColumna.busquedaTexto(
                    'Número documento',
                    'numeroDocumento',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Correo electrónico',
                dataIndex: 'correoElectronico',
                key: 'correoElectronico',
                sorter: (a, b) => 0, //a.correoElectronico ? a.correoElectronico.localeCompare(b.correoElectronico) : 1,
                filteredValue: filtro.correoElectronico || null,
                ...this.filtroColumna.busquedaTexto(
                    'Correo electrónico',
                    'correoElectronico',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Estado',
                key: 'estadoApoderado',
                align: 'center',
                dataIndex: 'estadoApoderado',
                sorter: (a, b) => 0, //a.estadoApoderado ? a.estadoApoderado.localeCompare(b.estadoApoderado) : 1,
                filteredValue: filtro.estadoApoderado || null,
                ...this.filtroColumna.busquedaOpciones(
                    'Estado',
                    'estadoApoderado',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) },
                    estadosApoderados
                ),
            },
            {
                title: 'Tipo persona',
                dataIndex: 'tipoPersona',
                key: 'tipoPersona',
                sorter: (a, b) => 0, //a.tipoPersona ? a.tipoPersona.localeCompare(b.tipoPersona) : 1,
                filteredValue: filtro.tipoPersona || null,
                ...this.filtroColumna.busquedaTexto(
                    'Tipo Persona',
                    'tipoPersona',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Nombre persona',
                dataIndex: 'nombrePersona',
                key: 'nombrePersona',
                sorter: (a, b) => 0, //a.nombrePersona ? a.nombrePersona.localeCompare(b.nombrePersona) : 1,
                filteredValue: filtro.nombrePersona || null,
                ...this.filtroColumna.busquedaTexto(
                    'Nombre Persona',
                    'nombrePersona',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Documento persona',
                dataIndex: 'tipoDocumentoPersona',
                key: 'tipoDocumentoPersona',
                sorter: (a, b) => 0, //a.tipoDocumentoPersona ? a.tipoDocumentoPersona.localeCompare(b.tipoDocumentoPersona) : 1,
                filteredValue: filtro.tipoDocumentoPersona || null,
                ...this.filtroColumna.busquedaTexto(
                    'Tipo Documento Persona',
                    'tipoDocumentoPersona',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Número persona',
                dataIndex: 'numeroDocumentoPersona',
                key: 'numeroDocumentoPersona',
                sorter: (a, b) => 0, //a.numeroDocumentoPersona ? a.numeroDocumentoPersona.localeCompare(b.numeroDocumentoPersona) : 1,
                filteredValue: filtro.numeroDocumentoPersona || null,
                ...this.filtroColumna.busquedaTexto(
                    'Número Documento Persona',
                    'numeroDocumentoPersona',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
        ];

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                            <Modal
                                visible={descargando}
                                closable={false}
                                footer={null}
                                width={320}
                                style={{ textAlign: 'center' }}
                            >
                                <label style={{ marginBottom: 13, display: 'block' }}>
                                    Generando reporte...
                                </label>
                                <Progress type="circle" percent={porcentaje} width={80} />
                            </Modal>

                            {
                                this.state.filtroEtiquetas.length > 0 ?
                                    (<div className="seccion-filtros-etiquetas">
                                        <div className="titulo-filtro-etiquetas">
                                            <label>Filtros <SearchOutlined /> :</label>
                                        </div>

                                        {
                                            this.state.filtroEtiquetas.map((filtroEtiqueta, i) => {
                                                return (
                                                    <FiltroEtiqueta key={i}
                                                        dataIndex={filtroEtiqueta.dataIndex}
                                                        texto={filtroEtiqueta.texto}
                                                        onClose={filtroEtiqueta.borrarFiltro} />
                                                )
                                            })
                                        }
                                    </div>)
                                    :
                                    (<></>)
                            }

                            <Table columns={columns}
                                dataSource={apoderados}
                                rowKey={"key"} 
                                onChange={this.handleTableChange}
                                pagination={this.state.paginacion}
                                loading={this.state.cargandoTabla}/>
                        </Spin>
                    )
                    :
                    (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                        (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                        : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:REPAPODER]</label>) : (<></>))
                }
            </div>

        );

    }

}

export default withRouter(withCookies(ReporteApoderados));